import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnMenuHamburger = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M3.75 12h16.5M3.75 5.75h16.5m-16.5 12.5h16.5"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnMenuHamburger;
